import React, { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import { useEdit } from '../../Services/EditContext';
import { FormLabel, FormValue } from './FormLabel';
import Selector from './Selector';
import LoadingAnimation from './LoadingAnimation';
import { useFetchEntity } from '../../Services/fetchApi';
import { endpoints } from '../../utils/Constants';

const ManufacturerSelector = ({ id, label = 'Manufacturer' }) => {
    const { values, setFieldValue } = useFormikContext();
    const [edit] = useEdit();
    const value = values[id];

    // Fetch manufacturers from the database

    const [manufacturerList, loading, error] = useFetchEntity({ name: "AircraftManufactures", getByStatus: () => endpoints.getAircraftManufactures });
    const [options, setOptions] = useState([]);

    // Convert manufacturer list to options format when data is loaded
    useEffect(() => {
        if (manufacturerList && Array.isArray(manufacturerList)) {
            const opts = manufacturerList.map(m => ({
                value: m.id,
                label: m.name
            }));
            setOptions(opts);
        }
    }, [manufacturerList]);

    const handleChange = (selectedOption) => {
        setFieldValue(id, selectedOption ? selectedOption.value : null);
    };

    if (loading) return <LoadingAnimation />;
    if (error) return <div>Error loading manufacturers</div>;

    if (!edit) {
        return <>
              <FormLabel htmlFor={id} style={{ display: 'block' }}>
                {label}
            </FormLabel>
            <FormValue>
                {value && options.find(opt => opt.value === value)?.label}
            </FormValue>
        </>;
    }
    return (
        <>
            <FormLabel htmlFor={id} style={{ display: 'block' }}>
                {label}
            </FormLabel>
            <Selector
                value={options.find(opt => opt.value === value)}
                onChange={handleChange}
                options={options}
                isClearable={true}
                isSearchable={true}
                placeholder={`Select...`}
            />
        </>
    );
};

export default ManufacturerSelector;
